var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"simple-bar__wrapper"},[_c('rect',{staticClass:"simple-bar__bar",attrs:{"x":"0","y":`${100 - _vm.value}%`,"width":"100%","height":`${_vm.value}%`,"fill":_vm.color}}),_c('text',{staticClass:"simple-bar__value",attrs:{"text-anchor":"middle","y":"32%","x":"50%"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }